import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const sentRfqSlice = createSlice({
  name: "sentRfq",

  initialState: {
    sentRfqData: [],
    isError1: false,
  },

  reducers: {
    fetchRfqSuccess: (state, action) => {
      state.isError1 = false;
      state.sentRfqData = action.payload;
    },
    fetchRfqFail: (state) => {
      state.isError1 = true;
    },
    resetState: (state) => {
      state.sentRfqData = [];
      state.isError1 = false;
    },
  },
});

export const { fetchRfqSuccess, fetchRfqFail, resetState } =
  sentRfqSlice.actions;

export const fetchSentRfq = (logout) => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/product-enquiry`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: config.token,
        Accept: "application/json",
      },
    });
    dispatch(fetchRfqSuccess(response.data.data));
  } catch (error) {
    dispatch(fetchRfqFail());
    if (error.response && error.response.status === 401) {
      logout();
    }
  }
};
export default sentRfqSlice.reducer;
